<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 12L10.5 16L18 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>